import { Injectable, signal } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AppStateService {

  // ================= STATE =================
  private _user = signal<any>(null);
  private _appConfig = signal<any>(null);

  user = this._user.asReadonly();
  appConfig = this._appConfig.asReadonly();

  constructor() {
    // ✅ Only restore APP CONFIG (not user)
    const app = localStorage.getItem(environment.appConfig);
    if (app) {
      const parsed = JSON.parse(app);
      this._appConfig.set(parsed);
      this.applyTheme(parsed.theme_color);
    }
  }

  // ================= USER =================
  setUser(user: any) {
    this._user.set(user);
  }

  clearUser() {
    this._user.set(null);
  }

  // ================= APP CONFIG =================
  setAppConfig(config: any) {
    this._appConfig.set(config);

    // ✅ store only app config
    localStorage.setItem(environment.appConfig, JSON.stringify(config));

    this.applyTheme(config.theme_color);
  }

  // ================= THEME =================
  private applyTheme(color: string) {
  if (!color) return;

  const root = document.documentElement;

  root.style.setProperty('--p-primary-color', color);
  root.style.setProperty('--p-primary-light-color', this.lighten(color, 92));
  root.style.setProperty('--p-primary-dark-color', this.lighten(color, 85));
  root.style.setProperty('--p-primary-hover-color', this.hexToRgba(color, 0.9));
}
private lighten(hex: string, percent: number): string {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = (num >> 16) + Math.round((255 - (num >> 16)) * percent / 100);
  const g = ((num >> 8) & 0x00FF) + Math.round((255 - ((num >> 8) & 0x00FF)) * percent / 100);
  const b = (num & 0x0000FF) + Math.round((255 - (num & 0x0000FF)) * percent / 100);

  return `rgb(${Math.min(255, r)}, ${Math.min(255, g)}, ${Math.min(255, b)})`;
}
private hexToRgba(hex: string, alpha: number): string {
  const bigint = parseInt(hex.replace('#', ''), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
}